import { Role } from "@/core/components/auth/auth.types";
import { ErrorComponent } from "@/core/components/ErrorComponent";
import { LoadingList } from "@/core/components/LoadingList";
import { metricsSearchSchema } from "@/core/components/sites/site/overview/metrics.types";
import { metricsQueryOptions } from "@/core/components/sites/site/overview/metricsQueryOptions";
import { get7DaysBackAndToday } from "@/core/lib/utils";
import { createFileRoute, redirect } from "@tanstack/react-router";
import { format } from "date-fns";

function getDefaultMetricsSearch() {
	const today = format(new Date(), "yyyy-MM-dd");
	return { startDate: today, endDate: today };
}

export const Route = createFileRoute("/_layout/dashboard/sites/$siteId/")({
	validateSearch: (search: Record<string, unknown>) => {
		const defaults = getDefaultMetricsSearch();
		const withDefaults = {
			startDate: (search.startDate as string) ?? defaults.startDate,
			endDate: (search.endDate as string) ?? defaults.endDate,
		};
		return metricsSearchSchema.parse(withDefaults);
	},
	beforeLoad: ({ context: { auth }, params: { siteId } }) => {
		if (auth.isExpired()) {
			return;
		}
		if (!auth.isAuthenticated) {
			throw redirect({
				to: "/",
			});
		}
		if (auth.user?.role === Role["Front-Desk"]) {
			const { from, to } = get7DaysBackAndToday();
			throw redirect({
				to: "/dashboard/sites/$siteId/reservations",
				params: { siteId },
				search: {
					page: 1,
					pageSize: 10,
					sortBy: "bookingDate",
					orderBy: "asc",
					fromDate: format(from, "yyyy-MM-dd"),
					endDate: format(to, "yyyy-MM-dd"),
					source: "Web",
					purchaseId: "",
					guestName: "",
					dateMode: "booking",
				},
			});
		}
	},
	loaderDeps: ({ search }) => {
		return {
			startDate: search.startDate,
			endDate: search.endDate,
		};
	},
	loader: ({ context: { queryClient, auth }, params: { siteId }, deps }) => {
		// eslint-disable-next-line @typescript-eslint/no-floating-promises
		queryClient.ensureQueryData(
			metricsQueryOptions(auth.token!, siteId, deps.startDate, deps.endDate),
		);
	},
	pendingComponent: LoadingList,
	errorComponent: ErrorComponent,
});
